import React from "react";

export default () => (
  <div className="w-full md:w-1/2 p-6 flex flex-col flex-grow flex-shrink">
    <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
      <div className="w-full font-bold text-l text-gray-800 px-6">Dokument</div>
      <p className="text-gray-800 text-sm px-6 mb-5">
        Central lagringsplats för samtliga anläggningsdokument.
        <br></br>
        <br></br>
        Ex:
        <ul className="text-gray-800 text-sm px-6 mb-5 list-disc">
          <li>Bygglov</li>
          <li>Tillstånd</li>
          <li>Kontrollrapporter</li>
          <li>Myndighetsprotokoll</li>
          <li>Manualer</li>
        </ul>
        Central lagringsplats för generella dokument.
        <br></br>
        <br></br>
        Ex:
        <ul className="text-gray-800 text-sm px-6 mb-5 list-disc">
          <li>Visuella manualer</li>
          <li>Säkerhetsdatablad</li>
          <li>Byggmanualer</li>
        </ul>
      </p>
    </div>
  </div>
);
